*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: contents;
}

dialog {
  transform: scale(var(--wui-scale-enter, 0.97));

  overflow: visible;

  box-sizing: border-box;
  max-width: min(90vw, var(--wui-dialog-max-width, 360px));
  max-height: 90vh;
  padding: 0;
  border: none;

  font-family: inherit;
  color: var(--wui-color-text, #1b1b1b);

  opacity: 0;
  background: transparent;

  transition:
    opacity var(--wui-duration-overlay-enter, 180ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1)),
    transform var(--wui-duration-overlay-enter, 180ms) var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));

  &::backdrop {
    opacity: 0;
    background: var(--wui-dialog-overlay-bg, var(--wui-color-backdrop, rgb(0 0 0 / 0.1)));
    transition: opacity var(--wui-duration-overlay-enter, 180ms) ease;
  }
}

dialog[open].is-visible {
  transform: scale(1);
  opacity: 1;
}

dialog.is-closing {
  pointer-events: none;
  transition-duration: var(--wui-duration-overlay-exit, 140ms);
}

dialog.is-closing::backdrop {
  transition-duration: var(--wui-duration-overlay-exit, 140ms);
}

dialog[open].is-visible::backdrop {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  dialog,
  dialog[open].is-visible {
    transform: none;
    transition-duration: var(--wui-duration-feedback, 100ms);
  }
}

/* ===== 玻璃卡片主体（样式由 glass.css 提供） ===== */

.wui-dialog-body {
  --wui-internal-glass-shadow: var(--wui-shadow-overlay, 2px 16px 40px rgb(0 0 0 / 0.4));
  padding: 32px 24px 24px;
  border-radius: 32px;
  background-color: var(--wui-color-surface-overlay, rgb(246 246 246 / 0.82));
}

/* ===== 标题 ===== */

.title {
  margin: 0 0 16px;
  padding: 0;

  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--wui-color-text, #1b1b1b);
}

/* ===== 描述 ===== */

.desc {
  margin: 0 0 24px;
  padding: 0;

  font-size: 14px;
  line-height: 1.5;
  color: var(--wui-color-text, #1b1b1b);
}

/* ===== 按钮区域 ===== */

.wui-dialog-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* ===== 按钮全宽（默认垂直排列） ===== */

  & ::slotted(web-ui-button) {
    display: flex;
    width: 100%;
  }
}

/* ===== horizontal 模式 ===== */

:host([horizontal]) .wui-dialog-footer {
  flex-direction: row;
  gap: 12px;
  justify-content: center;

  /* 非 full 按钮：居中，不拉伸 */

  & ::slotted(web-ui-button:not([full])) {
    width: auto;
  }

  /* full 按钮：平分剩余空间 */

  & ::slotted(web-ui-button[full]) {
    flex: 1;
    min-width: 0;
  }
}
